import React, { Component } from 'react'
import Collapse, { Panel } from 'rc-collapse'
import 'rc-collapse/assets/index.css'

import '../style/collapse.scss'

export default class Coll extends Component {
    render() {
        const { defaultActiveKey = null, activeKey: activeKeyVal, 
                items = [], onlyOneOpened = false, onChange } = this.props;
        const activeKeyProp = activeKeyVal ? {activeKey: activeKeyVal} : null;
        return (
            <Collapse 
                onChange={(e) => onChange && onChange(e)}
                {...activeKeyProp} 
                defaultActiveKey={defaultActiveKey} 
                className="collapse" accordion={onlyOneOpened}
                expandIcon={({ isActive }) => {
                    return <i style={{marginRight: "5px"}} 
                        className={"expand-icon fas fa-" + (isActive ? "minus active" : "plus")}></i>
                }}
            >
                {
                    items.map((item, i) => {
                        return (
                            <Panel forceRender={true} key={i} header={item.headerTitle} headerClass={"panel-header " + (item.headerClass)}>
                                <div className="panel">
                                    {item.content}
                                </div>
                            </Panel>
                        );
                    })
                }
            </Collapse>
        )
    }
}
